import { memo } from "react";
import { CardElement } from "@stripe/react-stripe-js";

import s from "./AddStripeCard.module.scss";
import stripeTrusted from "../../../assets/images/wl-security-badge-stripe.png";
import stripeTrustedDarkMode from "../../../assets/images/stripe-trusted-white.png";
import useAddCardProvider from "./provider";
import useStripePaymentMethodStore from "../store";
import { WLButton } from "../../../../Common/components/WLButton/WLButton";

const AddStripeCard = ({ darkMode }: { darkMode?: boolean }) => {
  const { onSavePaymentMethod } = useAddCardProvider();

  const { setStripeShowAddCard } = useStripePaymentMethodStore();
  return (
    <>
      <div className={s.addCardForm}>
        <CardElement />
      </div>
      <img
        className={s.stripeTrusted}
        src={darkMode ? stripeTrustedDarkMode : stripeTrusted}
        alt=""
        loading="lazy"
        decoding="async"
      />
      <WLButton
        onClick={() => {
          onSavePaymentMethod({ isDefault: false });
        }}
        color={darkMode ? undefined : "danger"}
        className="red-submit-button wl-body-6 ion-no-margin"
        isFormComponent
      >
        Save Card
      </WLButton>
      <WLButton
        onClick={() => {
          setStripeShowAddCard(false);
        }}
        color={darkMode ? undefined : "danger"}
        className="submit-button wl-body-6 ion-margin-top"
        fill="clear"
      >
        Cancel
      </WLButton>
    </>
  );
};

export default memo(AddStripeCard);
